import projectsConstants from './constants'
import projectsService from './services'

const checkNameAvailablity = (name, excludeProjectId) => {
  const request = () => ({
    type: projectsConstants.CHECK_NAME_AVAILABILITY_REQUEST
  })
  const success = () => ({
    type: projectsConstants.CHECK_NAME_AVAILABILITY_SUCCESS
  })
  const failure = (error) => ({
    error,
    type: projectsConstants.CHECK_NAME_AVAILABILITY_FAILURE
  })

  return (dispatch) => {
    dispatch(request())

    projectsService.checkNameAvailablity(name, excludeProjectId)
      .then(() => dispatch(success()))
      .catch((error) => dispatch(failure(error)))
  }
}

const create = (attributes) => {
  const request = () => ({ type: projectsConstants.CREATE_REQUEST })
  const success = (project) => ({
    project,
    type: projectsConstants.CREATE_SUCCESS
  })
  const failure = (error) => ({
    error,
    type: projectsConstants.CREATE_FAILURE
  })

  return (dispatch) => {
    dispatch(request())

    projectsService.create(attributes)
      .then((project) => dispatch(success(project)))
      .catch((error) => dispatch(failure(error)))
  }
}

const enqueueStatsRefresh = (slug) => {
  const request = () => ({
    type: projectsConstants.ENQUEUE_STATS_REFRESH_REQUEST
  })
  const success = () => ({
    slug,
    type: projectsConstants.ENQUEUE_STATS_REFRESH_SUCCESS
  })
  const failure = (error) => ({
    type: projectsConstants.ENQUEUE_STATS_REFRESH_FAILURE,
    error
  })

  return (dispatch) => {
    dispatch(request())

    projectsService.enqueueStatsRefresh(slug)
      .then((project) => dispatch(success(project)))
      .catch((error) => dispatch(failure(error)))
  }
}

const fetch = (slug) => {
  const request = () => ({
    type: projectsConstants.FETCH_REQUEST
  })
  const success = (project) => ({
    project,
    type: projectsConstants.FETCH_SUCCESS
  })
  const failure = (error) => ({
    type: projectsConstants.FETCH_FAILURE,
    error
  })

  return (dispatch) => {
    dispatch(request())

    projectsService.fetch(slug)
      .then((project) => dispatch(success(project)))
      .catch((error) => dispatch(failure(error)))
  }
}

const fetchAll = () => {
  const request = () => ({ type: projectsConstants.FETCH_ALL_REQUEST })
  const success = (projects) => ({
    projects,
    type: projectsConstants.FETCH_ALL_SUCCESS
  })
  const failure = (error) => ({
    error,
    type: projectsConstants.FETCH_ALL_FAILURE
  })

  return (dispatch) => {
    dispatch(request())

    projectsService.fetchAll()
      .then((projects) => dispatch(success(projects)))
      .catch((error) => dispatch(failure(error)))
  }
}

const fixingAlert = (projectId, selectedIds, locale) => {
  const request = () => ({ type: projectsConstants.FIXES_ALERT_REQUEST })
  const success = (project) => ({
    locale,
    project,
    selectedIds,
    type: projectsConstants.FIXES_ALERT_SUCCESS
  })
  const failure = (error) => ({
    error,
    type: projectsConstants.FIXES_ALERT_FAILURE
  })

  return (dispatch) => {
    dispatch(request())

    projectsService.fixesAlert(projectId, selectedIds, locale)
      .then((project) => dispatch(success(project)))
      .catch((error) => dispatch(failure(error)))
  }
}

const forceImport = (id, allFiles, gitOptions) => {
  const request = () => ({ id, type: projectsConstants.FORCE_IMPORT_REQUEST })
  const success = () => ({
    id,
    type: projectsConstants.FORCE_IMPORT_SUCCESS
  })
  const failure = (error) => ({
    error,
    type: projectsConstants.FORCE_IMPORT_FAILURE
  })

  return (dispatch) => {
    dispatch(request())

    projectsService.forceImport(id, allFiles, gitOptions)
      .then(() => dispatch(success()))
      .catch((error) => dispatch(failure(error)))
  }
}

const remove = (id) => {
  const request = () => ({ id, type: projectsConstants.REMOVE_REQUEST })
  const success = () => ({ id, type: projectsConstants.REMOVE_SUCCESS })
  const failure = (error) => ({
    error,
    type: projectsConstants.REMOVE_FAILURE
  })

  return (dispatch) => {
    dispatch(request())

    projectsService.remove(id)
      .then(() => dispatch(success()))
      .catch((error) => dispatch(failure(error)))
  }
}

const update = (id, referenceLanguages, name, paths, repositoryBranchName) => {
  const request = () => ({ type: projectsConstants.UPDATE_REQUEST })
  const success = (project) => ({
    project,
    type: projectsConstants.UPDATE_SUCCESS
  })
  const failure = (error) => ({
    error,
    type: projectsConstants.UPDATE_FAILURE
  })

  return (dispatch) => {
    dispatch(request())

    projectsService.update(id, referenceLanguages, name, paths, repositoryBranchName)
      .then((project) => dispatch(success(project)))
      .catch((error) => dispatch(failure(error)))
  }
}

const refreshLogo = (id) => {
  const request = () => ({ type: projectsConstants.REFRESH_LOGO_REQUEST })
  const success = (project) => ({
    project,
    type: projectsConstants.REFRESH_LOGO_SUCCESS
  })
  const failure = (error) => ({
    error,
    type: projectsConstants.REFRESH_LOGO_FAILURE
  })

  return (dispatch) => {
    dispatch(request())

    projectsService.refreshLogo(id)
      .then((project) => dispatch(success(project)))
      .catch((error) => dispatch(failure(error)))
  }
}

const bulkLink = (integrationId, projects) => {
  const request = () => ({ type: projectsConstants.BULK_LINK_REQUEST })
  const success = (results) => ({
    results,
    type: projectsConstants.BULK_LINK_SUCCESS
  })
  const failure = (error) => ({
    error,
    type: projectsConstants.BULK_LINK_FAILURE
  })

  return (dispatch) => {
    dispatch(request())

    projectsService.bulkLink(integrationId, projects)
      .then((response) => {
        dispatch(success(response.results))
        // Refresh projects list to get updated integration_id
        dispatch(fetchAll())
      })
      .catch((error) => dispatch(failure(error)))
  }
}

const resetBulkLink = () => ({ type: projectsConstants.BULK_LINK_RESET })

export default {
  bulkLink,
  checkNameAvailablity,
  create,
  enqueueStatsRefresh,
  fetch,
  fetchAll,
  fixingAlert,
  forceImport,
  refreshLogo,
  remove,
  resetBulkLink,
  update
}
